import Barba from 'barba.js'

export default Barba.BaseTransition.extend({
    start() {
        this.newContainerLoading.then(this.finish.bind(this));
    },
    finish() {
        window.scrollTo(0, 0);
        this.done();
    }
})